<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Document Files</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <strong>Add new Documents</strong>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              :to="{ name: 'DocumentFilesManageDocs', params: { id: $route.params.id }}"
            >
              Manage Documents
            </router-link>
          </div>

          <div class="card-block">
            <div class="row images-dd__wrap">
              <div class="col-md-6">
                <div class="images-dd__target-zone">
                  <div class="images-dd__target-zone__title">
                    Documents which will add to Document files:
                  </div>
                  <div class="images-dd__list">
                    <div
                      v-for="item in selectedDocs"
                      :key="item.id"
                      class="images-dd__item"
                      :data-id="item.id"
                      :title="item.title"
                    >
                      <div class="images-dd__item__img">
                        <img :src="item.thumbnail" alt="">
                      </div>
                      <div class="images-dd__item__title">{{ shortTitle(item.title) }}</div>
                      <div class="images-dd__item__cover" @click="deleteDoc(item)">
                        <i class="fa fa-minus" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="images-dd__source-wrap spinner-parent">
                  <div class="images-dd__source-search">
                    <input
                      v-model="searchQuery"
                      type="text"
                      class="form-control"
                      placeholder="Search by document title"
                    >
                  </div>

                  <div class="spinner-parent">
                    <spinner ref="sourceSpinner" size="md" text="Loading ..." />

                    <div class="images-dd__list">
                      <div
                        v-for="item in sourceDocs"
                        :key="item.id"
                        class="images-dd__item"
                        :data-id="item.id"
                      >
                        <div class="images-dd__item__img">
                          <img :src="item.thumbnail" alt="">
                        </div>
                        <div class="images-dd__item__title" :title="item.title">
                          {{ shortTitle(item.title) }}
                        </div>
                        <div class="images-dd__item__cover" @click="addDoc(item)">
                          <i class="fa fa-plus" />
                        </div>
                      </div>

                      <div v-if="!total" class="images-dd__list--empty">
                        There are no items on your request
                      </div>
                    </div>

                    <nav class="images-dd__source-nav">
                      <pager
                        :total="total"
                        :offset="offset"
                        :size="perPage"
                        @page-changed="changePage"
                      />
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save Docs
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Docs have saved successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';

export default {
  name: 'DocumentFilesAddDocs',

  components: {
    pager: Pager,
  },

  data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceDocs: [],
      selectedDocs: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getSourceDocs();
    }, 400),
    offset() {
      this.getSourceDocs();
    },
  },

  mounted() {
    this.getSourceDocs();
  },

  methods: {
    shortTitle(title) {
      if (title.length > 30) {
        return `${title.slice(0, 30)}...`;
      }
      return title;
    },
    addDoc(doc) {
      const index = _.findIndex(this.selectedDocs, item => doc.id === item.id);
      if (index === -1) {
        this.selectedDocs.push(doc);
      }
    },
    deleteDoc(doc) {
      _.remove(this.selectedDocs, item => item.id === doc.id);
      this.$forceUpdate();
    },
    getSourceDocs() {
      if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/documents?search_string=${searchString}&page=${page}`)
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;

            const docsArr = _.cloneDeep(response.data);
            delete docsArr.meta;
            this.sourceDocs = docsArr;
          }
        }).catch((error) => {
          if (this.$refs.sourceSpinner) { this.$refs.sourceSpinner.hide(); }
          console.error(error);
        });
    },
    changePage(offset) {
      this.offset = offset;
    },
    isEntityValid() {
      if (!this.selectedDocs.length) {
        this.errorSave('You should choose at least one document');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      for (let i = 0; i < this.selectedDocs.length; i += 1) {
        postFormData.append('ids[]', this.selectedDocs[i].id);
      }
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/document-files/${this.$route.params.id}/attach/media-docs`,
        postFormData,
      );
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.successSave();
        this.selectedDocs = [];
        this.$forceUpdate();
      }).catch((error) => {
        this.errorSave('Error in data saving');
        console.error('Error in add docs to document files query', error);
      });
    },
    successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
  },
};
</script>



// WEBPACK FOOTER //
// AddDocs.vue?5e765b4c